<template>
  <div>
    <div class="row">
      <div class="col-6">
        <div>
          <img alt="" class="w-100" src="../assets/agreement.jpg">
        </div>
      </div>
      <!--<div class="col-6 p-3">-->
      <!--<div>-->
      <!---->
      <!--</div>-->
      <!--</div>-->
      <div class="col-6 p-3">
        <div v-html="agreementText"></div>

        <div class="d-flex justify-content-between" style="align-items: center">
          <div class="col-6">
            <q-checkbox label="I agree to this terms & conditions" v-model="acceptAgreement"></q-checkbox>
          </div>
          <div class="col-6 " v-if="acceptAgreement">
            <q-btn @click="sendOtp" class="pd-btn" size="12px">I Agree</q-btn>
          </div>
        </div>

      </div>


    </div>


    <q-dialog persistent transition-hide="scale" transition-show="scale" v-model="VerifyOtpDialog">
      <q-card>
        <div class="row ">
          <div class="col-6" style="background: #f2f7f4;">
            <img alt="otp" class="w-100" src="../assets/otp.png">
          </div>
          <div class="col-6 p-2" style="background: #f2f7f4;">

            <div class="w-100">
              <q-btn class="float-right" color="primary" dense flat icon="close" v-close-popup>
                <q-tooltip>Close</q-tooltip>
              </q-btn>
            </div>
            <div>
              <h5>
                Verify OTP
              </h5>
            </div>

            <div class="py-2 mt-3 mb-3">
              <h6 style="font-size: 16px;">Enter the verification code we just sent your mobile number
                {{ userObj.mobile }}.</h6>
            </div>
            <div>
              <q-input class="mb-3" label="Enter OTP" mask="####" v-model="otp"></q-input>

              <q-btn :disable="verifyOtpDisabled" @click="verifyOtp" class="pd-btn my-3 q-pr-lg" size="12px">Verify
                OTP
              </q-btn>

              <q-btn @click="sendOtp" class="btn-resend ml-2 my-3" size="12px">Resend OTP</q-btn>
            </div>
          </div>
        </div>
        <!--<q-bar class="bg-teal text-white">-->
        <!--<div>Verify OTP</div>-->
        <!--<q-space />-->
        <!--<q-btn dense flat icon="close" v-close-popup>-->
        <!--<q-tooltip>Close</q-tooltip>-->
        <!--</q-btn>-->
        <!--</q-bar>-->

        <!--<q-card-section>-->
        <!--Please enter OTP send on mobile number {{userObj.mobile}}-->
        <!--</q-card-section>-->

        <!--<q-card-section>-->
        <!--<div class="row q-col-gutter-md">-->
        <!--<div class="col-xs-8">-->
        <!--<q-input label="Enter OTP" v-model="otp"></q-input>-->
        <!--</div>-->
        <!--<div class="col-xs-4 text-center q-mt-md">-->
        <!--<q-btn @click="verifyOtp" color="primary" size="12px">Verify OTP</q-btn>-->
        <!--</div>-->
        <!--</div>-->
        <!--</q-card-section>-->

        <!--<q-card-actions align="right" class="bg-white text-teal">-->
        <!--<q-btn flat label="Cancel" v-close-popup />-->
        <!--</q-card-actions>-->
      </q-card>
    </q-dialog>


  </div>
</template>

<script>
import { GET_AGREEMENT } from '../graphql/queries/setting'
import Constants from '../Constants/Constant'
import { NetworkCommunicator } from '../plugins/NetworkResourceHandler'

export default {
  apollo: {
    Setting: {
      query: GET_AGREEMENT,
      fetchPolicy: 'network-only',
      variables () {
        return {
          name: this.userObj.organization.partnerType == '921a8e09-766f-4894-b04c-495059858bb4'
              ? 'VAP Agreement'
              : 'VAD Agreement',
        }
      },
      result ({ data, loading }) {
        if (!loading) {
          this.agreementText = data.Setting.length ? data.Setting[0].value : null
        }
      },
    },
  },
  name: 'Aggrement',
  data: function () {
    return {
      agreementText: '',
      acceptAgreement: false,
      VerifyOtpDialog: false,
      otp: '',
      otpId: '',
      userObj: JSON.parse(localStorage.getItem('user')),
      verifyOtpDisabled: false,
    }
  },
  methods: {
    async sendOtp () {
      let request = {
        'userId': this.userObj.id,
        'orgId': this.userObj.orgId,
        'mobile': this.userObj.mobile,
      }
      this.VerifyOtpDialog = true
      let response = await NetworkCommunicator('POST',
          `${Constants.api_url}sendOTP`, false, request, {})
      if (response.flag) {
        this.otpId = response.data.id
        this.verifyOtpDisabled = false
        this.$q.notify(response.message)
        // this.otp = response.data.otp
      } else {
        this.$q.notify('Send OTP failed')
      }
    },
    async verifyOtp () {
      let self = this
      let request = {
        'id': this.otpId,
        'otp': this.otp,
      }
      let response = await NetworkCommunicator('POST',
          `${Constants.api_url}VerifyOtp`, false, request, {})
      if (response.flag) {
        // this.$q.notify('OTP verified successfully')
        this.VerifyOtpDialog = false
        setTimeout(function () {self.$router.replace({ path: '/Partners/Dashboard' })}, 500)
      } else {
        if (response.code === 41) {
          this.$q.notify(response.message) //Invalid OTP
        } else if (response.code === 202) {
          this.$q.notify(response.message) //Maximum Try
          this.verifyOtpDisabled = true
          this.otp = ''
          this.otpId = ''
        } else {
          this.$q.notify(response.message)
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
